<template>
    <div
        class="RequirementTypeList__header"
        :class="{ 'RequirementTypeList__header--actionsOnly': !showTitle }"
    >
        <strong v-if="showTitle">{{ title }}</strong>
        <div class="flex flex-wrap gap-2">
            <NewButton
                v-if="showEvaluationRuleButton && !disableEvaluationRule && canEditEvaluationRule"
                variant="outline"
                color="primary"
                @click="$emit('toggle-evaluation-rule-modal')"
            >
                <template v-if="hasEvaluationRule">
                    Edit Evaluation Rule
                </template>
                <template v-else>
                    Set Evaluation Rule
                </template>
            </NewButton>
            <AddRiskRequirement
                :available-requirement-options="availableRequirementOptions"
                :enabled="canAddRequirement"
                @select="onSelectRequirement"
            />
        </div>
    </div>
</template>

<script lang="ts">
    import { defineComponent, PropType } from 'vue';

    import { DropdownOption } from '@evidentid/dashboard-commons/components/Dropdown';
    import { TprmRequirementType } from '@evidentid/tprm-portal-lib/models/entity-details';

    import NewButton from '@/components/new-button/NewButton.vue';
    import AddRiskRequirement from '@/modules/decisioning-criteria/components/RequirementTypeList/AddRiskRequirement.vue';

    export default defineComponent({
        name: 'RequirementsEditorToolbar',
        components: {
            AddRiskRequirement,
            NewButton,
        },
        props: {
            title: {
                type: String,
                default: 'Requirements',
            },
            showTitle: {
                type: Boolean,
                default: true,
            },
            showEvaluationRuleButton: {
                type: Boolean,
                default: true,
            },
            hasEvaluationRule: {
                type: Boolean,
                default: false,
            },
            disableEvaluationRule: {
                type: Boolean,
                default: false,
            },
            canEditEvaluationRule: {
                type: Boolean,
                default: false,
            },
            canAddRequirement: {
                type: Boolean,
                default: false,
            },
            availableRequirementOptions: {
                type: Array as PropType<DropdownOption<TprmRequirementType>[]>,
                default: (): DropdownOption<TprmRequirementType>[] => [],
            },
        },
        emits: [ 'add', 'toggle-evaluation-rule-modal' ],
        methods: {
            onSelectRequirement(option?: DropdownOption<TprmRequirementType>): void {
                if (option) {
                    this.$emit('add', option.value);
                }
            },
        },
    });
</script>
